import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { PageMeta } from './PageMeta'
import { ShowcaseMyReviewDto } from './ShowcaseMyReviewDto'
/**
* Class PageOfShowcaseMyReviewDto
*  Результат постраничного запроса
*/
export class PageOfShowcaseMyReviewDto extends ActiveModel {

  /**
  * meta
  * Meta-информация о результате постраничного запроса  */
  @ActiveField({
    factory: [PageMeta, () => undefined]
  })
  meta?: PageMeta


/**
  * @property items
  * Список элементов страницы<br>  */
  @ActiveField({
    factory: [ShowcaseMyReviewDto, () => undefined]
  })
  items?: Array<ShowcaseMyReviewDto>
}
